import { useLocation, useNavigate } from 'react-router-dom';

import { useSubscribe } from './useSubscribe';

export function RouteChangeListener({ startsWith = '/' }) {
  const location = useLocation();
  const navigate = useNavigate();
  useSubscribe<{ pathname: string; search: string }>(
    'route:change',
    ({ pathname, search }) => {
      if (
        pathname.startsWith(startsWith) &&
        (location.pathname !== pathname || location.search !== search)
      ) {
        navigate({ pathname, search });
      }
    },
  );
  return null;
}
